
namespace GeniuzPOS.PriceChange {
    import fld = ApprovePriceChangeRow.Fields;
    // @Serenity.Decorators.filterable()
    @Serenity.Decorators.registerClass()
    export class ApprovePriceChangeGrid extends Serenity.EntityGrid<ApprovePriceChangeRow, any> {
        protected getColumnsKey() { return ApprovePriceChangeColumns.columnsKey; }
        protected getDialogType() { return ApprovePriceChangeDialog; }
        protected getIdProperty() { return ApprovePriceChangeRow.idProperty; }
        protected getInsertPermission() { return ApprovePriceChangeRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovePriceChangeRow.localTextPrefix; }
        protected getService() { return ApprovePriceChangeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        // protected setInitialSortOrder(): void {
            
        // }
        protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {

            let filters = super.getQuickFilters();
            Q.first(filters, x => x.field == fld.ApproveFg).init = w => {
                (w as Serenity.EnumEditor).value = "0";
                ;
            };    
            // Q.first(filters, x => x.field == fld.PostFg).init = w => {
            //     (w as Serenity.EnumEditor).value = "0";
            //     ;
            // };    
            // filters.splice(Q.indexOf(filters, x => x.cssClass == 'select2-container select2-allowclear s-Serenity-EnumEditor s-EnumEditor'), 1)              
         
            
            return filters;
        }          
        
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["  "]);
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        } 
    }
}